import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import calendars from 'scoreboard/components/calendars'
import template from './my-metrics.hbs'
import metricRow from './my-metrics-metric-row.hbs'
import orgRow from '../filtered-list/filtered-list-org-row.hbs'
import FilteredList from '../filtered-list/filtered-list'
import noMetricsOwned from '../no-metrics-owned.hbs'
import config from 'scoreboard/components/config'
import { shortenedAndUnshortened }  from 'scoreboard/components/format-value'
import actualValueCompartor from 'scoreboard/components/actual-value-comparator'
import HomeNav from '../home-nav'
import { isV5 } from 'scoreboard/components/version'

function getDisplayHeading() {
	return i18n.get('home.myMetrics')
}

var MyMetrics = FilteredList.extend({

	_template: template,

	_countKeyPrefix: 'scorecards.node.metric.number',

	_filterIcon: 'metric',

	_displayHomeNav: true,

	heading: getDisplayHeading,

	className: 'filtered-list home my-metrics panes table-hack display-layout scroll-layout-xy',

	emptyTemplate: noMetricsOwned,

	initialize: function(options = {}) {
		options.sortOptions = {
			fields: ['label', 'periodLabel', 'score', 'actual'],
			numeric: ['score', 'actual'],
			applySortingOptions: (opts, field, state) => {
				//#14530 handle N/A
				if (field =='actual') {
					opts.compare = actualValueCompartor
				}
				return opts
			},
			extractSortData: (item, field) => {
				if (field == 'actual') return item.score
				if (field == 'score') return _.get(item.score, 'score', null)
				if (field == 'periodLabel') {
					let periodId = calendars.defaultPeriods[item.calendarId]
					return calendars.periodsById[periodId].label
				}
				return item[field]
			}
		}
		FilteredList.prototype.initialize.call(this, options)
	},

	renderHomeNav: function(container) {
		if (isV5()) {
			return
		}
		this.homeNav = new HomeNav({
			section: 'my-metrics'
		})
		container.prepend(this.homeNav.el)
		this.homeNav.render()
	},

	_renderObject: function(metric) {
		var html = ''
		,	periodId = calendars.defaultPeriods[metric.calendarId]
		,	actual = metric.score && shortenedAndUnshortened({ value: metric.score.actual, dataType: metric.score.dataType, currencyCode: metric.currencyCode, precision: metric.precision })
		,	score = metric.score && shortenedAndUnshortened({
				value: metric.score.score,
				dataType: 'score'
			})

		html += metricRow({
			id: metric.id,
			label: metric.label,
			color: metric.score && metric.score.color || 'gray',
			periodLabel: calendars.periodsById[periodId].label,
			score: score && score.shortened,
			scoreUnshortened: score && (score.unshortened != score.shortened ? score.unshortened : null),
			actual: actual && actual.shortened,
			actualUnshortened: actual && (actual.unshortened != actual.shortened ? actual.unshortened : null)
		})
		return html
	},

	_getColor: function(metric) {
		return metric.score ? metric.score.color : 'gray'
	},

	_updateDisplay: function() {
		FilteredList.prototype._updateDisplay.apply(this, arguments)
		if (!config.scoresVisible) {
			this.$('.metric-score').hide()
		}
	},

	_orgRowMeta: _.memoize(function() {
		return {
			template: orgRow,
			colspan: 4
		}
	}),

	remove: function() {
		FilteredList.prototype.remove.apply(this, arguments)
		_.invokeMap([this.nonAbbreviatedTooltip], 'remove')
	}
})

export default MyMetrics

MyMetrics.__filename__ = 'home/my-metrics/my-metrics.js'
